module.exports = __webpack_public_path__ + "img/ts22.b585e4e1.png";